interface YouTubeEmbedProps {
  videoId: string
  className?: string
}

export default function YouTubeEmbed({ videoId, className }: YouTubeEmbedProps) {
  return (
    <div
      className={`relative w-full aspect-video rounded-card overflow-hidden bg-black [transform:translateZ(0)]${className ? ` ${className}` : ''}`}
    >
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
        className="absolute inset-0 w-full h-full border-0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
        title="HBO Max / Discovery video"
      />
    </div>
  )
}
